import ClientsList from '../../components/clients/list'

const ClientsPage = () => {
  return (
    <div className='container-with-bg w-full'>
      <ClientsList />
    </div>
  )
}

export default ClientsPage
